import {IsPositive, IsNumber, IsUUID, IsNotEmpty} from 'class-validator';
import { EventDto } from './event.dto';

export class EventDonationToMembershipDto {
	public id: string;
	public eventId: string;
	public membershipId: string;
	public donationNumber: number;

	public event?: EventDto;
}

export class CreateEventDonationToMembershipDto {
	@IsUUID()
	@IsNotEmpty()
	public membershipId: string;

	@IsNumber()
	@IsPositive({
		message: 'Donation amount should be a positive number',
	})
	@IsNotEmpty()
	public donationNumber: number;	
}

export class UpdateEventDonationToMembershipDto {
	@IsUUID()
	@IsNotEmpty()
	public eventId: string;

	@IsNumber()
	@IsPositive({
		message: 'Donation amount should be a positive number',
	})
	@IsNotEmpty()
	public donationNumber: number;

	@IsUUID()
	@IsNotEmpty()
	public membershipId: string;
}
